import { render, staticRenderFns } from "./DestinationTabNoResults.vue?vue&type=template&id=c86cf6b4&scoped=true&"
import script from "./DestinationTabNoResults.vue?vue&type=script&lang=js&"
export * from "./DestinationTabNoResults.vue?vue&type=script&lang=js&"
import style0 from "./DestinationTabNoResults.vue?vue&type=style&index=0&id=c86cf6b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86cf6b4",
  null
  
)

export default component.exports